import RemoteDataStrategy from "./api-client/remote-data-strategy";
import LocalDataStrategy from "./api-client/base-data-strategy";

class ApiService {
    constructor() {
        this.remoteDataStrategy = new RemoteDataStrategy();
        this.localDataStrategy = new LocalDataStrategy();
        this.dataStrategy = null;
        this.goOnline();
    }

    goOnline(online = true) {
        this.dataStrategy = online
            ? this.remoteDataStrategy
            : this.localDataStrategy;
    }
}

export default ApiService;
